import React, { useState } from 'react';
import { getAvatarUrl } from '../../utils/avatarUtils';

interface AvatarProps {
  src?: string;
  alt?: string;
  username?: string;
  className?: string;
  size?: number;
}

export const Avatar: React.FC<AvatarProps> = ({ 
  src, 
  alt, 
  username, 
  className = '', 
  size = 40 
}) => {
  const [hasError, setHasError] = useState(false);
  
  const handleError = () => {
    setHasError(true);
  };
  
  const avatarSrc = hasError ? getAvatarUrl(undefined, username) : getAvatarUrl(src, username);
  
  return (
    <img
      src={avatarSrc}
      alt={alt || username || 'User avatar'}
      className={className}
      onError={handleError}
      style={{ width: size, height: size }}
    />
  );
};